export const scrollTo = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
    element.style.filter = "drop-shadow(0 0 1rem #85C1E9)";
    setTimeout(() => {
      element.style.filter = "unset";
    }, 1000);
  }
};
